var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import EntrustDeliverService from '../../../api/EntrustDeliverService';
import CommonService from "../../../api/CommonService";
import { fieldConfig } from '../config';
var deliverService = EntrustDeliverService.getInstance();
var BatchEditDialog = (function (_super) {
    __extends(BatchEditDialog, _super);
    function BatchEditDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visible = false;
        _this.loading = false;
        _this.formItems = [];
        _this.fieldErrors = {};
        _this.nextId = 1;
        _this.accountOptions = [];
        return _this;
    }
    BatchEditDialog.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.getAccountOptions();
    };
    BatchEditDialog.prototype.getAccountOptions = function () {
        var _this = this;
        this.commonService.getAccountOptions().then(function (res) {
            if (res.data.success) {
                _this.accountOptions = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    Object.defineProperty(BatchEditDialog.prototype, "canAddField", {
        get: function () {
            return this.formItems.length < fieldConfig.length;
        },
        enumerable: true,
        configurable: true
    });
    BatchEditDialog.prototype.show = function (selectedRows) {
        this.selectedRows = selectedRows;
        this.visible = true;
        this.loading = false;
        this.initForm();
    };
    BatchEditDialog.prototype.initForm = function () {
        var today = new Date().toISOString().split('T')[0];
        this.formItems = [{
                id: this.nextId++,
                fieldKey: fieldConfig[0].key,
                value: fieldConfig[0].type === 'date' ? today : '',
                error: ''
            }];
    };
    BatchEditDialog.prototype.getAvailableFields = function (currentIndex) {
        var selectedKeys = this.formItems
            .filter(function (_, index) { return index !== currentIndex; })
            .map(function (item) { return item.fieldKey; });
        return fieldConfig.filter(function (field) { return !selectedKeys.includes(field.key); });
    };
    BatchEditDialog.prototype.getFieldType = function (fieldKey) {
        var field = fieldConfig.find(function (f) { return f.key === fieldKey; });
        return field.type || 'text';
    };
    BatchEditDialog.prototype.getFieldLabel = function (fieldKey) {
        var field = fieldConfig.find(function (f) { return f.key === fieldKey; });
        return field.label || '';
    };
    BatchEditDialog.prototype.getPlaceholder = function (fieldKey) {
        if (fieldKey === 'logistics_no') {
            return '请输入物流单号，多个单号时"、"顿号相隔';
        }
        if (fieldKey === 'reciever_address') {
            return '请输入收货地址';
        }
        if (fieldKey === 'reciever_phone') {
            return '请输入收货人电话';
        }
        if (fieldKey === 'deliverer_phone') {
            return '请输入送货人手机号';
        }
        if (fieldKey === 'delivery_plate_number') {
            return '请输入送货车牌号';
        }
        return '请输入' + this.getFieldLabel(fieldKey);
    };
    BatchEditDialog.prototype.addField = function () {
        var today = new Date().toISOString().split('T')[0];
        var usedKeys = this.formItems.map(function (item) { return item.fieldKey; });
        var availableField = fieldConfig.find(function (field) { return !usedKeys.includes(field.key); });
        if (availableField) {
            this.formItems.push({
                id: this.nextId++,
                fieldKey: availableField.key,
                value: availableField.type === 'date' ? today : '',
                error: ''
            });
        }
    };
    BatchEditDialog.prototype.removeField = function (index) {
        this.formItems.splice(index, 1);
        this.validateForm();
    };
    BatchEditDialog.prototype.handleFieldChange = function (index) {
        this.formItems[index].value = '';
        this.validateForm();
    };
    BatchEditDialog.prototype.handleDelivererChange = function (delivererId) {
        if (delivererId) {
            var selectedDeliverer = this.accountOptions.find(function (item) { return item.account_id === delivererId; });
            console.log('选中的送货人数据:', selectedDeliverer);
            if (selectedDeliverer) {
                var phoneFieldIndex = this.formItems.findIndex(function (item) { return item.fieldKey === 'deliverer_phone'; });
                if (phoneFieldIndex !== -1) {
                    var phone = selectedDeliverer.phone || selectedDeliverer.mobile || selectedDeliverer.telephone || selectedDeliverer.account_phone || selectedDeliverer.user_phone || '';
                    this.formItems[phoneFieldIndex].value = phone;
                }
            }
        }
    };
    BatchEditDialog.prototype.handleSubmit = function () {
        var _this = this;
        var errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.fieldErrors = errors;
            return;
        }
        var orderIds = this.selectedRows
            .map(function (row) { return row.order_id || row.id; })
            .filter(function (id) { return id != null && id !== ''; })
            .join(',');
        if (!orderIds) {
            this.$message.error('没有有效的订单ID');
            return;
        }
        var params = { order_ids: orderIds };
        var updatedFields = [];
        this.formItems.forEach(function (item) {
            if (!item.value && item.value !== 0) {
                return;
            }
            var value = _this.sanitizeValue(item.value);
            if (!value && value !== 0) {
                return;
            }
            switch (item.fieldKey) {
                case 'receiver_phone':
                    params.reciever_phone = value.toString();
                    updatedFields.push('收货人电话');
                    break;
                case 'receiver_address':
                    params.reciever_address = value.toString();
                    updatedFields.push('收货地址');
                    break;
                case 'deliver_user':
                    var memberId = parseInt(value.toString());
                    if (!isNaN(memberId)) {
                        params.delivery_member_id = memberId;
                        updatedFields.push('送货人');
                    }
                    break;
                case 'deliverer_phone':
                    params.deliverer_phone = value.toString();
                    updatedFields.push('送货人手机号');
                    break;
                case 'delivery_plate_number':
                    params.delivery_plate_number = value.toString();
                    updatedFields.push('送货车牌号');
                    break;
                case 'deliver_time':
                    if (_this.isValidDate(value)) {
                        params.delivery_time = value;
                        updatedFields.push('送货时间');
                    }
                    break;
                case 'logistics_code':
                    params.logistics_number = value.toString();
                    updatedFields.push('物流单号');
                    break;
                case 'remark':
                    params.remark = value.toString();
                    updatedFields.push('备注');
                    break;
            }
        });
        if (updatedFields.length === 0) {
            this.$message.warning('请至少修改一个字段');
            return;
        }
        params.order_icomment = params.remark;
        this.loading = true;
        (this.$props.type === 'delivery' ? deliverService.batchUpdateDeliveryInfo(params) : deliverService.batchUpdateEntrustInfo(params)).then(function (res) {
            _this.$message.success('修改成功');
            _this.visible = false;
            _this.loading = false;
            _this.$emit('success', {
                success: true,
                message: "\u6279\u91CF\u4FEE\u6539\u4E86 " + _this.selectedRows.length + " \u6761\u8BB0\u5F55",
                updatedFields: updatedFields
            });
        }).catch(function (err) {
            _this.loading = false;
            _this.$message.error(err.message || err.msg || '修改失败');
        });
    };
    BatchEditDialog.prototype.isValidPhone = function (phone) {
        var phoneRegex = /^1[3-9]\d{9}$/;
        return phoneRegex.test(phone);
    };
    BatchEditDialog.prototype.validatePhone = function (index) {
        var item = this.formItems[index];
        if (!item.value) {
            this.fieldErrors[item.fieldKey] = '';
            return;
        }
        if (!this.isValidPhone(item.value)) {
            this.fieldErrors[item.fieldKey] = '手机号格式无效';
        }
        else {
            this.fieldErrors[item.fieldKey] = '';
        }
    };
    BatchEditDialog.prototype.isValidLogisticsCode = function (code) {
        return /^[a-zA-Z0-9、]+$/.test(code);
    };
    BatchEditDialog.prototype.sanitizeLogisticsCode = function (code) {
        return code.replace(/[^a-zA-Z0-9、]/g, '');
    };
    BatchEditDialog.prototype.handleLogisticsInput = function (index, value) {
        var item = this.formItems[index];
        item.value = this.sanitizeLogisticsCode(value);
    };
    BatchEditDialog.prototype.validateLogistics = function (index) {
        var item = this.formItems[index];
        if (!item.value) {
            this.fieldErrors[item.fieldKey] = '';
            return;
        }
        if (!this.isValidLogisticsCode(item.value)) {
            this.fieldErrors[item.fieldKey] = '请输入正确的物流单号';
        }
        else {
            this.fieldErrors[item.fieldKey] = '';
        }
    };
    BatchEditDialog.prototype.validateForm = function () {
        var _this = this;
        var errors = {};
        this.formItems.forEach(function (item) {
            var value = item.value;
            if (_this.getFieldType(item.fieldKey) === 'phone' && value) {
                if (!_this.isValidPhone(value)) {
                    errors[item.fieldKey] = '手机号格式无效';
                }
            }
            if (_this.getFieldType(item.fieldKey) === 'number' && value) {
                if (!_this.isValidLogisticsCode(value)) {
                    errors[item.fieldKey] = '请输入正确的物流单号';
                }
            }
        });
        this.fieldErrors = errors;
        return errors;
    };
    BatchEditDialog.prototype.sanitizeValue = function (value) {
        if (value === undefined || value === null)
            return '';
        if (typeof value === 'string')
            return value.trim();
        return value;
    };
    BatchEditDialog.prototype.isValidDate = function (dateStr) {
        var date = new Date(dateStr);
        return date instanceof Date && !isNaN(date.getTime());
    };
    BatchEditDialog.prototype.handleClose = function () {
        this.formItems = [];
        this.fieldErrors = {};
    };
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], BatchEditDialog.prototype, "selectedRows", void 0);
    __decorate([
        Prop({ type: String, default: '' })
    ], BatchEditDialog.prototype, "type", void 0);
    BatchEditDialog = __decorate([
        Component({
            name: 'BatchEditDialog'
        })
    ], BatchEditDialog);
    return BatchEditDialog;
}(Vue));
export default BatchEditDialog;
